import { forwardRef } from 'react';
import styles from './legend.module.css';
import clsx from 'clsx';

export type LegendProps = React.ComponentPropsWithoutRef<'legend'>;

export const Legend = forwardRef<HTMLLegendElement, LegendProps>(
  function Legend({ className, ...rest }, ref) {
    return (
      <legend className={clsx(styles.legend, className)} ref={ref} {...rest} />
    );
  }
);
